export const GLOBAL_CREDIT = 'Глобал Кредит';
export const RUBRIC = 'Рубрика';
export const BLOG = 'Блог';
